import { Flex, Skeleton, Text } from "@/atoms"

import styles from "../InventorySnapshotWidget.module.scss"

import type { DemoCardProps } from ".."

export const getDemoCard = (props: DemoCardProps) => {
  const { isDemo, loading } = props
  const { title, to, data } = props

  if (!isDemo) return { title, to, ...data }

  return {
    title: undefined,
    span: 4,
    value: data.value,
    to: loading ? undefined : to,
    valueRender: (value: React.ReactNode) => {
      const gap = loading ? 6 : 0

      return (
        <Flex vertical className={styles.demoStatisticCard} gap={gap}>
          <Flex justify="space-between" align="center" flex={1}>
            {loading && (
              <Flex flex={1}>
                <Skeleton.Input
                  active
                  size="small"
                  className={styles.demoStatisticCardTitleSkeleton}
                />
              </Flex>
            )}
            {!loading && (
              <>
                <Flex className={styles.demoStatisticCardTitle}>
                  <Text ellipsis type="secondary">
                    {title}
                  </Text>
                </Flex>
                <Flex className={styles.demoStatisticCardValue}>{value}</Flex>
              </>
            )}
          </Flex>
          {loading && <Skeleton.Button active size="small" />}
          {!loading && (
            <Text type="secondary" className={styles.demoStatisticCardExtra}>
              {data.extra}
            </Text>
          )}
        </Flex>
      )
    }
  }
}
